"use client";
import UseSticky from "@/hooks/UseSticky";
import { Icon } from "@/svg/Icon";
import React, { useState, useEffect } from "react";

type style_type = {
  style?: boolean;
};
const ScrollToTop = ({ style }: style_type) => {
  const { sticky }: { sticky: boolean } = UseSticky();

  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  return (
    <>
      <div
        className={`back-to-top-wrapper${style ? "back_to_top-2" : ""} ${
          sticky && "back-to-top-btn-show"
        }`}
      >
        <button
          onClick={scrollTop}
          id="back_to_top"
          type="button"
          className="back-to-top-btn"
        >
          <Icon name="ScrollToTop" />
        </button>
      </div>
    </>
  );
};

export default ScrollToTop;
